module.exports = __webpack_public_path__ + "static/img/hacker.441e4b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/hacker.jpg
// module id = t28W
// module chunks = 1